/**
 * On-mount IndexedDB recovery probe.
 *
 * Asks the IDB store whether there are persisted chunks for this meeting
 * — typically left behind by a tab close / browser crash mid-recording —
 * and surfaces them via `setRecovered`. The recovery banner takes it from
 * there.
 *
 * No age limit: any unsubmitted recording is worth recovering, even if
 * the user comes back days later.
 */
import { useEffect } from "react"
import { loadChunksFromIDB, type SavedRecording } from "../../../hooks/useIndexedDB"

interface IProps {
  meetingId: string
  setRecovered: (saved: SavedRecording | null) => void
}

export function useRecoveryLoader({ meetingId, setRecovered }: IProps): void {
  useEffect(() => {
    loadChunksFromIDB(meetingId).then((saved) => {
      if (saved && saved.chunks.length > 0) {
        setRecovered(saved)
      }
    })
  }, [meetingId, setRecovered])
}
